<template>
  <div class="flex justify-center py-6">
    <svg
      width="179"
      height="178"
      viewBox="0 0 179 178"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.23"
        d="M86.1165 170.564C133.641 170.564 172.168 132.472 172.168 85.4832C172.168 38.4944 133.641 0.402344 86.1165 0.402344C38.5918 0.402344 0.0654297 38.4944 0.0654297 85.4832C0.0654297 132.472 38.5918 170.564 86.1165 170.564Z"
        fill="#9BA0A7"
      />
      <path
        opacity="0.46"
        d="M85.2869 178C130.126 178 166.475 175.842 166.475 173.181C166.475 170.52 130.126 168.363 85.2869 168.363C40.4479 168.363 4.09863 170.52 4.09863 173.181C4.09863 175.842 40.4479 178 85.2869 178Z"
        fill="#5E646D"
      />
      <path
        d="M62.3536 66.5219L29.5558 66.9039C28.8646 66.9119 28.183 67.0653 27.5564 67.3538C26.9297 67.6423 26.3723 68.0593 25.9212 68.5771C25.47 69.0949 25.1355 69.7018 24.9397 70.3572C24.744 71.0127 24.6915 71.7019 24.7858 72.379L33.7232 136.328C33.885 137.492 34.4712 138.557 35.3714 139.323C36.2716 140.089 37.4239 140.504 38.6117 140.49L139.776 139.318C140.964 139.305 142.105 138.863 142.986 138.076C143.867 137.289 144.428 136.211 144.562 135.045L150.743 79.764C150.794 79.3117 150.746 78.854 150.604 78.4211C150.462 77.9883 150.229 77.5901 149.92 77.2531C149.611 76.9161 149.233 76.6478 148.811 76.466C148.389 76.2843 147.933 76.1932 147.472 76.1988L70.3741 77.0952L67.6079 69.5319C67.087 68.6092 66.324 67.8425 65.3992 67.3128C64.4745 66.783 63.4223 66.5098 62.3536 66.5219Z"
        fill="#5E646D"
      />
      <path
        d="M62.3745 68.0707L29.5767 68.4476C28.8868 68.456 28.2066 68.6091 27.5809 68.8966C26.9552 69.1841 26.3984 69.5996 25.9471 70.1156C25.4958 70.6316 25.1603 71.2364 24.9629 71.89C24.7654 72.5436 24.7104 73.2313 24.8015 73.9075L31.9154 137.877L146.401 136.553L150.759 81.2976C150.809 80.8454 150.761 80.388 150.618 79.9555C150.476 79.523 150.243 79.1252 149.934 78.7884C149.625 78.4515 149.247 78.1833 148.825 78.0013C148.404 77.8192 147.948 77.7276 147.488 77.7324L70.3898 78.6288L67.6184 71.0655C67.0968 70.1468 66.3346 69.3839 65.4119 68.8569C64.4892 68.33 63.44 68.0584 62.3745 68.0707Z"
        fill="#9BA0A7"
      />
      <path
        d="M26.1357 85.8957L31.9154 137.897L146.401 136.567L150.512 84.4492L26.1357 85.8957Z"
        fill="#9BA0A7"
      />
      <path
        d="M84.6087 34.508L26.0107 45.623L40.1107 118.291L98.7087 107.176L84.6087 34.508Z"
        fill="#F3F6F9"
      />
      <g style="mix-blend-mode:multiply" opacity="0.42">
        <path
          d="M84.6075 34.5117L83.7112 34.6849L74.4287 106.819L90.1863 108.8L98.7064 107.181L84.6075 34.5117Z"
          fill="#9BA0A7"
        />
      </g>
      <path
        d="M75.0709 41.9156L37.6396 49.0156L38.2569 52.1969L75.6882 45.0968L75.0709 41.9156Z"
        fill="#507FDF"
      />
      <path
        d="M83.3824 84.7456L45.9512 91.8457L46.5684 95.0269L83.9997 87.9269L83.3824 84.7456Z"
        fill="#9BA0A7"
      />
      <path
        d="M84.6256 91.1441L47.1943 98.2441L47.8116 101.425L85.2428 94.3253L84.6256 91.1441Z"
        fill="#9BA0A7"
      />
      <path
        d="M85.8678 97.5347L48.4365 104.635L49.0538 107.816L86.485 100.716L85.8678 97.5347Z"
        fill="#9BA0A7"
      />
      <path
        d="M66.6387 48.4827L47.9307 52.0312L48.2393 53.6219L66.9473 50.0733L66.6387 48.4827Z"
        fill="#9BA0A7"
      />
      <path
        d="M57.3226 58.6212L36.6162 62.5488L36.9248 64.1394L57.6312 60.2118L57.3226 58.6212Z"
        fill="#9BA0A7"
      />
      <path
        d="M58.2356 63.338L37.5293 67.2656L37.8379 68.8562L58.5443 64.9286L58.2356 63.338Z"
        fill="#9BA0A7"
      />
      <path
        d="M59.1546 68.0528L38.4482 71.9805L38.7569 73.5711L59.4632 69.6435L59.1546 68.0528Z"
        fill="#9BA0A7"
      />
      <path
        d="M60.0676 72.7696L39.3613 76.6973L39.67 78.2879L60.3763 74.3602L60.0676 72.7696Z"
        fill="#9BA0A7"
      />
      <path
        d="M60.9807 77.4864L40.2744 81.4141L40.583 83.0047L61.2894 79.077L60.9807 77.4864Z"
        fill="#9BA0A7"
      />
      <path
        d="M61.8987 82.1954L41.1924 86.123L41.501 87.7137L62.2074 83.786L61.8987 82.1954Z"
        fill="#9BA0A7"
      />
      <path
        d="M82.3157 53.8829L61.6094 57.8105L61.918 59.4012L82.6243 55.4735L82.3157 53.8829Z"
        fill="#9BA0A7"
      />
      <path
        d="M83.2229 58.5939L62.5166 62.5215L62.8252 64.1121L83.5315 60.1845L83.2229 58.5939Z"
        fill="#9BA0A7"
      />
      <path
        d="M84.1419 63.3106L63.4355 67.2383L63.7442 68.8289L84.4505 64.9013L84.1419 63.3106Z"
        fill="#9BA0A7"
      />
      <path
        d="M85.055 68.0274L64.3486 71.9551L64.6573 73.5457L85.3636 69.6181L85.055 68.0274Z"
        fill="#9BA0A7"
      />
      <path
        d="M85.9729 72.7423L65.2666 76.6699L65.5752 78.2605L86.2815 74.3329L85.9729 72.7423Z"
        fill="#9BA0A7"
      />
      <path
        d="M86.886 77.4571L66.1797 81.3848L66.4883 82.9754L87.1947 79.0478L86.886 77.4571Z"
        fill="#9BA0A7"
      />
      <path
        d="M145.994 41.234L86.8047 33.7891L77.3604 107.191L136.55 114.636L145.994 41.234Z"
        fill="#F3F6F9"
      />
      <path
        d="M134.603 45.3416L96.7939 40.5859L96.3805 43.7993L134.19 48.555L134.603 45.3416Z"
        fill="#507FDF"
      />
      <path
        d="M128.386 89.0064L90.6533 84.1074L90.2274 87.3143L127.96 92.2132L128.386 89.0064Z"
        fill="#9BA0A7"
      />
      <path
        d="M127.53 95.4517L89.7969 90.5527L89.371 93.7596L127.104 98.6585L127.53 95.4517Z"
        fill="#9BA0A7"
      />
      <path
        d="M127.372 101.527L89.5625 96.7715L89.1491 99.9848L126.958 104.741L127.372 101.527Z"
        fill="#9BA0A7"
      />
      <path
        d="M124.52 48.9941L105.623 46.6172L105.416 48.2239L124.313 50.6007L124.52 48.9941Z"
        fill="#9BA0A7"
      />
      <path
        d="M112.482 55.7616L91.5664 53.1309L91.3597 54.7375L112.275 57.3683L112.482 55.7616Z"
        fill="#9BA0A7"
      />
      <path
        d="M111.867 60.5312L90.9521 57.9004L90.7454 59.5071L111.661 62.1378L111.867 60.5312Z"
        fill="#9BA0A7"
      />
      <path
        d="M111.254 65.2909L90.3389 62.6602L90.1321 64.2668L111.047 66.8976L111.254 65.2909Z"
        fill="#9BA0A7"
      />
      <path
        d="M110.641 70.0566L89.7256 67.4258L89.5189 69.0324L110.434 71.6632L110.641 70.0566Z"
        fill="#9BA0A7"
      />
      <path
        d="M110.029 74.8163L89.1133 72.1855L88.9066 73.7922L109.822 76.423L110.029 74.8163Z"
        fill="#9BA0A7"
      />
      <path
        d="M109.415 79.58L88.5 76.9492L88.2933 78.5559L109.209 81.1866L109.415 79.58Z"
        fill="#9BA0A7"
      />
      <path
        d="M137.718 58.9413L116.803 56.3105L116.596 57.9172L137.511 60.548L137.718 58.9413Z"
        fill="#9BA0A7"
      />
      <path
        d="M137.105 63.7011L116.189 61.0703L115.983 62.677L136.898 65.3077L137.105 63.7011Z"
        fill="#9BA0A7"
      />
      <path
        d="M136.492 68.4648L115.576 65.834L115.369 67.4407L136.285 70.0714L136.492 68.4648Z"
        fill="#9BA0A7"
      />
      <path
        d="M135.877 73.2304L114.962 70.5996L114.755 72.2063L135.671 74.8371L135.877 73.2304Z"
        fill="#9BA0A7"
      />
      <path
        d="M135.264 77.9941L114.349 75.3633L114.142 76.9699L135.057 79.6007L135.264 77.9941Z"
        fill="#9BA0A7"
      />
      <path
        d="M134.651 82.7538L113.735 80.123L113.529 81.7297L134.444 84.3605L134.651 82.7538Z"
        fill="#9BA0A7"
      />
      <path
        d="M144.645 168.638L34.208 169.922C32.9117 169.937 31.6544 169.483 30.672 168.647C29.6895 167.81 29.0493 166.649 28.8714 165.379L19.1201 95.5774C19.0171 94.8379 19.0743 94.0851 19.2879 93.369C19.5015 92.6529 19.8667 91.99 20.3592 91.4241C20.8516 90.8581 21.4602 90.4022 22.1444 90.0865C22.8287 89.7709 23.573 89.6026 24.328 89.593L152.593 88.1058C153.349 88.0974 154.097 88.2479 154.789 88.5474C155.481 88.847 156.101 89.2886 156.607 89.843C157.113 90.3974 157.494 91.0519 157.725 91.7631C157.956 92.4743 158.031 93.2259 157.945 93.968L149.873 163.983C149.723 165.255 149.11 166.429 148.147 167.286C147.185 168.143 145.94 168.624 144.645 168.638Z"
        fill="#9BA0A7"
      />
      <path
        d="M144.665 170.192L34.2381 171.476C32.9418 171.491 31.6845 171.037 30.7021 170.201C29.7196 169.364 29.0794 168.203 28.9015 166.933L19.1348 97.1263C19.0317 96.3863 19.089 95.6331 19.3029 94.9167C19.5168 94.2003 19.8825 93.5371 20.3755 92.9711C20.8685 92.4051 21.4777 91.9492 22.1626 91.6339C22.8475 91.3185 23.5923 91.1508 24.3478 91.1419L152.613 89.6547C153.368 89.6455 154.116 89.7953 154.808 90.0943C155.5 90.3933 156.119 90.8345 156.625 91.3886C157.131 91.9428 157.512 92.5971 157.742 93.308C157.972 94.019 158.046 94.7702 157.96 95.5118L149.888 165.527C149.742 166.801 149.131 167.978 148.169 168.837C147.207 169.696 145.961 170.178 144.665 170.192Z"
        fill="#5E646D"
      />
      <path
        opacity="0.34"
        d="M96.5644 122.513C113.758 117.032 123.203 98.8076 117.659 81.8076C112.116 64.8077 93.6834 55.4698 76.4896 60.9508C59.2958 66.4318 49.8513 84.6562 55.3948 101.656C60.9383 118.656 79.3706 127.994 96.5644 122.513Z"
        fill="#9BA0A7"
      />
      <path
        d="M131.62 125.893L117.976 113.725L112.7 119.507L126.344 131.675L131.62 125.893Z"
        fill="#5E646D"
      />
      <path
        d="M127.68 122.379L121.916 117.238L116.641 123.021L122.405 128.162L127.68 122.379Z"
        fill="#9BA0A7"
      />
      <path
        d="M123.509 137.76C122.713 137.048 122.235 136.053 122.18 134.993C122.125 133.933 122.497 132.895 123.215 132.106L132.312 122.139C132.668 121.749 133.098 121.432 133.578 121.206C134.057 120.981 134.577 120.851 135.108 120.824C135.638 120.797 136.169 120.873 136.67 121.049C137.17 121.225 137.631 121.497 138.025 121.849L171.312 151.791L156.59 167.514L123.509 137.76Z"
        fill="#9BA0A7"
      />
      <path
        d="M162.349 172.652L156.59 167.514L171.312 151.791L176.865 156.742C177.661 157.453 178.138 158.447 178.193 159.506C178.248 160.565 177.876 161.602 177.159 162.39L168.062 172.362C167.342 173.149 166.337 173.621 165.266 173.675C164.195 173.73 163.146 173.362 162.349 172.652Z"
        fill="#1034A6"
      />
      <path
        d="M132.312 122.139L128.228 126.611L164.461 159.11L171.312 151.791L138.025 121.849C137.631 121.497 137.17 121.225 136.67 121.049C136.169 120.873 135.638 120.797 135.108 120.824C134.577 120.851 134.058 120.981 133.578 121.206C133.098 121.432 132.668 121.749 132.312 122.139Z"
        fill="#1034A6"
      />
      <path
        d="M173.09 166.851L177.16 162.39C177.877 161.602 178.249 160.565 178.194 159.506C178.139 158.447 177.662 157.453 176.866 156.742L171.313 151.791L164.462 159.11L173.09 166.851Z"
        fill="#9BA0A7"
      />
      <path
        d="M45.7924 93.7994C46.2075 101.765 49.0024 109.43 53.8234 115.825C58.6444 122.22 65.2751 127.058 72.877 129.727C80.479 132.396 88.7106 132.776 96.5311 130.819C104.352 128.863 111.41 124.657 116.813 118.734C122.216 112.812 125.721 105.438 126.886 97.5455C128.05 89.653 126.822 81.5963 123.355 74.3943C119.888 67.1922 114.34 61.1683 107.41 57.0843C100.481 53.0002 92.4828 51.0394 84.4265 51.4499C73.6234 52.0004 63.4839 56.7714 56.2386 64.7135C48.9933 72.6556 45.2357 83.1181 45.7924 93.7994ZM119.192 90.0661C119.524 96.4531 117.933 102.794 114.62 108.287C111.307 113.779 106.421 118.178 100.58 120.925C94.7387 123.672 88.2049 124.646 81.8045 123.722C75.4041 122.797 69.4245 120.018 64.6219 115.734C59.8194 111.45 56.4095 105.854 54.8234 99.6535C53.2373 93.4534 53.5464 86.9275 55.7114 80.901C57.8765 74.8745 61.8003 69.6181 66.9867 65.7965C72.1731 61.9749 78.3892 59.7596 84.8489 59.4309C93.5113 58.9928 101.995 61.9738 108.435 67.7185C114.875 73.4633 118.745 81.5016 119.192 90.0661Z"
        fill="#9BA0A7"
      />
      <path
        d="M61.0561 90.0015C60.3195 79.8152 72.5021 63.0079 90.655 65.3405"
        stroke="#9BA0A7"
        stroke-width="12.35"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        opacity="0.12"
        d="M104.202 64.5254C112.352 88.8349 98.8194 112.177 78.4463 123.097C85.9719 124.989 93.933 124.173 100.906 120.794C107.879 117.415 113.408 111.694 116.505 104.653C119.603 97.6128 120.066 89.7125 117.812 82.3653C115.558 75.0182 110.734 68.7036 104.202 64.5509V64.5254Z"
        fill="#5E646D"
      />
      <path
        d="M119.192 90.0671C119.307 92.3072 119.19 94.5531 118.842 96.7696C118.128 101.216 116.484 105.467 114.015 109.25C111.546 113.033 108.306 116.266 104.502 118.741C100.698 121.216 96.4136 122.879 91.9227 123.625C87.4318 124.37 82.833 124.182 78.4201 123.071C74.9819 124.908 71.3556 126.378 67.6025 127.456C72.6152 130.053 78.1195 131.59 83.7655 131.969C89.4115 132.349 95.0756 131.563 100.398 129.662C105.72 127.76 110.584 124.785 114.68 120.924C118.776 117.063 122.015 112.402 124.191 107.237C126.367 102.072 127.432 96.5159 127.319 90.9218C127.205 85.3277 125.916 79.8182 123.532 74.7434C121.149 69.6686 117.724 65.1396 113.475 61.4444C109.225 57.7492 104.245 54.9685 98.8498 53.2793C101.07 56.8094 102.866 60.5835 104.202 64.525C108.575 67.2966 112.217 71.0598 114.824 75.5022C117.431 79.9445 118.928 84.9377 119.192 90.0671Z"
        fill="#5E646D"
      />
      <path
        d="M51.1197 93.4994C51.4803 100.423 53.909 107.085 58.099 112.644C62.2889 118.203 68.0517 122.409 74.659 124.73C81.2662 127.051 88.4211 127.383 95.2191 125.683C102.017 123.984 108.153 120.33 112.85 115.183C117.548 110.037 120.597 103.628 121.611 96.7683C122.626 89.9085 121.56 82.9053 118.55 76.6442C115.539 70.383 110.718 65.1451 104.697 61.5927C98.6753 58.0402 91.7238 56.3328 84.7211 56.6862C80.0692 56.9197 75.5095 58.0573 71.3027 60.0342C67.0958 62.011 63.3242 64.7883 60.2036 68.2072C57.083 71.6261 54.6745 75.6197 53.1158 79.9595C51.5571 84.2993 50.8788 88.9003 51.1197 93.4994ZM119.193 90.0361C119.526 96.4242 117.935 102.766 114.622 108.261C111.309 113.755 106.423 118.155 100.581 120.903C94.7395 123.652 88.2045 124.626 81.8028 123.702C75.4011 122.778 69.4202 119.999 64.6163 115.714C59.8125 111.43 56.4016 105.833 54.8149 99.6316C53.2282 93.4304 53.537 86.9032 55.7022 80.8755C57.8674 74.8478 61.7918 69.5903 66.9792 65.7678C72.1665 61.9454 78.3838 59.7297 84.8447 59.4009C89.1347 59.1819 93.4262 59.8006 97.4743 61.2218C101.522 62.6429 105.248 64.8386 108.437 67.6835C111.627 70.5284 114.219 73.9666 116.064 77.8019C117.91 81.6373 118.973 85.7945 119.193 90.0361Z"
        fill="#7B858F"
      />
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
